module.exports = __webpack_public_path__ + "img/03.23e366b0.png";